import { supabase } from '../lib/supabase/client';
import { ClientPortfolio } from '../types/models';
import { Database } from '../types/database.types';

type PortfolioRow = Database['public']['Tables']['client_portfolios']['Row'];
type PortfolioInsert = Database['public']['Tables']['client_portfolios']['Insert'];

export const portfolioService = {
  async getAll(): Promise<ClientPortfolio[]> {
    const { data, error } = await supabase
      .from('client_portfolios')
      .select('*')
      .order('created_at', { ascending: false });
    
    if (error) throw error;
    
    return (data || []).map((row: PortfolioRow) => ({
      id: row.id,
      customerName: row.customer_name,
      customerEmail: row.customer_email,
      projectTitle: row.project_title,
      projectDescription: row.project_description,
      roomType: row.room_type,
      stylePreference: row.style_preference,
      fabricPreference: row.fabric_preference,
      colorScheme: row.color_scheme,
      imageUrls: row.image_urls,
      referenceImages: row.reference_images,
      budgetRange: row.budget_range,
      timeline: row.timeline,
      specialRequirements: row.special_requirements,
      createdAt: row.created_at,
      updatedAt: row.updated_at,
    }));
  },

  async create(portfolio: Omit<ClientPortfolio, 'id' | 'createdAt' | 'updatedAt'>): Promise<ClientPortfolio> {
    const insertData: PortfolioInsert = {
      customer_name: portfolio.customerName,
      customer_email: portfolio.customerEmail,
      project_title: portfolio.projectTitle,
      project_description: portfolio.projectDescription,
      room_type: portfolio.roomType,
      style_preference: portfolio.stylePreference,
      fabric_preference: portfolio.fabricPreference,
      color_scheme: portfolio.colorScheme,
      image_urls: portfolio.imageUrls,
      reference_images: portfolio.referenceImages,
      budget_range: portfolio.budgetRange,
      timeline: portfolio.timeline,
      special_requirements: portfolio.specialRequirements,
    };

    const { data, error } = await supabase
      .from('client_portfolios')
      .insert(insertData)
      .select()
      .single();
    
    if (error) throw error;
    
    return {
      id: data.id,
      customerName: data.customer_name,
      customerEmail: data.customer_email,
      projectTitle: data.project_title,
      projectDescription: data.project_description,
      roomType: data.room_type,
      stylePreference: data.style_preference,
      fabricPreference: data.fabric_preference,
      colorScheme: data.color_scheme,
      imageUrls: data.image_urls,
      referenceImages: data.reference_images,
      budgetRange: data.budget_range,
      timeline: data.timeline,
      specialRequirements: data.special_requirements,
      createdAt: data.created_at,
      updatedAt: data.updated_at,
    };
  },
};